import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    categories: [],
    priceGroups: [],
    view: [],
    totalItems: 0,
    documents: []
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    totalItems: (state) => state.totalItems,
    documents: (state) => state.documents,
    itemOptions: (state) => state.items.map(entry => {
      return {
        text: entry.name,
        value: entry['@id']
      }
    }),
    categoryOptions: (state) => state.categories.map(entry => {
      return {
        text: entry.name,
        value: entry['@id']
      }
    }),
    priceGroupOptions: (state) => state.priceGroups.map(entry => {
      return {
        text: entry.name,
        value: entry['@id']
      }
    })
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    },
    setTotalItems (state, totalItems) {
      state.totalItems = totalItems
    },
    setDocuments (state, payload) {
      state.documents = payload
    },
    setCategories (state, payload) {
      state.categories = payload
    },
    setPriceGroups (state, payload) {
      state.priceGroups = payload
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_s_b_items') {
      commit('toggleLoading')
      const response = await new ApiService(url, { pagination: false }).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('setTotalItems', await response.totalItems)
      commit('toggleLoading')
    },
    async getCategories ({ commit }, url = 'e_x_s_b_items_categories') {
      const response = await new ApiService(url, { pagination: false }).getResults()
      commit('setCategories', await response.items)
    },
    async getPriceGroups ({ commit }, url = 'e_x_s_b_price_groups') {
      const response = await new ApiService(url, { pagination: false }).getResults()
      commit('setPriceGroups', await response.items)
    },
    async fetchDocuments ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_documents', baseParams).getResults()
      commit('setDocuments', response.items)
    }
  }
}
